import { isMobile } from './ScreenUtil';
import ViewUtil from '../ViewUtil';

export function isTreeViewEnable() {
  if (isMobile()) {
    return false;
  } else if (ViewUtil.getFolderNavView()) {
    return ViewUtil.getTreeView();
  } else {
    return false;
  }
}

export function isFolderNavEnable() {
  if (isMobile()) {
    return false;
  } else {
    return ViewUtil.getFolderNavView();
  }
}
